/**
 * Limits and checks for a redaction reason's fields.
 * Mirrors server/models/redaction_reason.py and server/routers/reasons.py so the
 * editor can't submit a payload the API will reject with a 422.
 */

export const TITLE_MAX_LENGTH = 200;
export const DESCRIPTION_MAX_LENGTH = 750;
export const CITATION_MAX_LENGTH = 200;
export const LEGAL_TEXT_MAX_LENGTH = 10000;
export const URL_MAX_LENGTH = 2048;

/** The link is printed in exported logs, so only web links are allowed. Empty is fine. */
export function isValidReasonUrl(url: string): boolean {
  const trimmed = url.trim();
  return trimmed === "" || /^https?:\/\//i.test(trimmed);
}
